export const TYPES = {
  GET_HOLIDAYS_REQUEST: "GET_HOLIDAYS_REQUEST",
  GET_HOLIDAYS_SUCCESS: "GET_HOLIDAYS_SUCCESS",
  SAVE_HOLIDAYS_SUCCESS: "SAVE_HOLIDAYS_SUCCESS",

  GET_AFTER_HOURS_REQUEST: "GET_AFTER_HOURS_REQUEST",
  GET_AFTER_HOURS_SUCCESS: "GET_AFTER_HOURS_SUCCESS",
  SAVE_AFTER_HOURS_SUCCESS: "SAVE_AFTER_HOURS_SUCCESS",

  GET_GENERAL_REQUEST: "GET_GENERAL_REQUEST",
  GET_GENERAL_SUCCESS: "GET_GENERAL_SUCCESS",
  SAVE_GENERAL_SUCCESS: "SAVE_GENERAL_SUCCESS",
};
